var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { BASE_URL_SERVICES } from '../services/constants';
import { nowParsedString } from './helpers/dateHelpers';
import { KeycloakEntity } from './KeycloakEntity';
// When the SSE (Server-Sent Events) stream stops, it is no longer an error. The readyState property then triggers a value of 4, indicating that the work is done.
var StreamEntity = /** @class */ (function () {
    function StreamEntity(url, errorCallback) {
        var _this = this;
        this.channels = [];
        this.channelsUrl = '';
        this.previousCompleteMessage = 0;
        this.messageIDProcess = [];
        this.isClosed = false;
        this.openSSE = function () {
            var _a;
            if (_this.channels.length > 0) {
                var channelsToUrl = _this.channels.map(function (chan) { return "".concat(chan.channel).concat(_this.parseChannelParam(chan.params)); }).join(',');
                _this.channelsUrl = channelsToUrl.length ? "?subscriptions=".concat(channelsToUrl) : '';
                var completeUrl = "".concat(BASE_URL_SERVICES).concat(_this.endpoint).concat(_this.channelsUrl);
                // Recreate instance if it was closed
                if (!_this.instance) {
                    _this.init();
                }
                _this.instance.open('GET', completeUrl, true);
                _this.instance.setRequestHeader('Authorization', "Bearer ".concat((_a = KeycloakEntity.kc) === null || _a === void 0 ? void 0 : _a.token));
                // SSE start
                _this.instance.send();
                _this.isClosed = false;
                StreamEntity.addStreamRunning({ url: completeUrl, id: _this.id, stream: _this, date: nowParsedString() });
            }
        };
        this.readMessages = function (instance) {
            var response = instance.response.match(/(data:.+[^\n])/g);
            if (response) {
                var responseToProcess_1 = response.slice(_this.previousCompleteMessage);
                // As we can receive multiple message in one batch we need to loop
                responseToProcess_1.forEach(function (message, index) {
                    var _a;
                    try {
                        var responseSeparatorIndex = message.indexOf(':');
                        var key = message.substring(0, responseSeparatorIndex);
                        var value = message.substring(responseSeparatorIndex + 1);
                        var parsed = JSON.parse(value);
                        _this.parseMessagesIncoming((_a = {}, _a[key] = parsed, _a));
                        _this.previousCompleteMessage = index;
                    }
                    catch (e) {
                        if (index !== responseToProcess_1.length - 1) {
                            console.error("Wrong format of message, can't parse it");
                        }
                    }
                });
            }
        };
        this.handleConnectionChange = function (event) {
            var now = nowParsedString();
            var completeUrl = "".concat(BASE_URL_SERVICES).concat(_this.endpoint).concat(_this.channelsUrl);
            if (event.target.readyState === 2) {
                _this.previousCompleteMessage = 0;
                console.info("%cSSE connection on : ".concat(completeUrl, " at ").concat(now), 'color: #4AAD52');
            }
            if (event.target.readyState === 4 && _this.endpoint && _this.channelsUrl.length && !_this.isClosed) {
                // If no channels are subscribed, we receive invalid header "has a charset ("iso-8859-1") that is not UTF-8" so don't try to reconnect
                // If we don't listen some channels
                // When we add some channels we automatically open new connection
                console.info("%cTrying SSE reconnect ".concat(now), 'color: #4AAD52');
                _this.reOpenSSE();
            }
        };
        this.id = Math.random().toString();
        this.endpoint = url;
        this.errorCallback = errorCallback;
        this.init();
    }
    StreamEntity.prototype.init = function () {
        var _this = this;
        this.instance = new XMLHttpRequest();
        this.instance.onprogress = function () { return _this.readMessages(_this.instance); };
        this.instance.onerror = this.handleErrorConnection;
        this.instance.onreadystatechange = this.handleConnectionChange;
    };
    // Don't delete all data, just close the connection, that permit to reopen it without recreate object
    StreamEntity.prototype.closeSSE = function () {
        var now = nowParsedString();
        var completeUrl = "".concat(BASE_URL_SERVICES).concat(this.endpoint).concat(this.channelsUrl);
        console.info("%cSSE connection off : ".concat(completeUrl, " at ").concat(now), 'color: #4AAD52');
        if (this.instance) {
            this.isClosed = true;
            this.instance.abort();
            this.instance = null;
        }
        this.messageIDProcess = [];
        StreamEntity.removeStreamRunning(this.id);
    };
    // Don't forget to stop on cleanup function of your useEffect or you're gonna face to memory leak
    StreamEntity.prototype.stopSSE = function () {
        this.closeSSE();
        this.channelsUrl = '';
        this.channels = [];
        this.endpoint = null;
        this.errorCallback = null;
        this.id = null;
    };
    StreamEntity.prototype.addListenerChannel = function (channel) {
        if (Array.isArray(channel)) {
            this.channels = this.channels.concat(channel);
        }
        else {
            this.channels.push(channel);
        }
    };
    StreamEntity.prototype.removeListenerChannel = function (channel) {
        if (Array.isArray(channel)) {
            this.channels = this.channels.filter(function (chan) { return channel.indexOf(chan.channel) === -1; });
        }
        else {
            this.channels = this.channels.filter(function (chan) { return chan.channel !== channel; });
        }
    };
    StreamEntity.addStreamRunning = function (streamToAdd) {
        this.streamRunning = __spreadArray(__spreadArray([], this.streamRunning, true), [streamToAdd], false);
    };
    StreamEntity.removeStreamRunning = function (streamId) {
        this.streamRunning = this.streamRunning.filter(function (stream) { return stream.id !== streamId; });
    };
    StreamEntity.stopAllSSE = function () {
        return Promise.all(this.streamRunning.map(function (streamRunning) { return streamRunning.stream.stopSSE(); }));
    };
    StreamEntity.prototype.reconnect = function (attempt) {
        if (attempt === void 0) { attempt = 1; }
        return __awaiter(this, void 0, void 0, function () {
            var now;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        now = nowParsedString();
                        if (!(attempt < 3)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.closeSSE()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.openSSE()];
                    case 2:
                        _a.sent();
                        if (this.instance) {
                            return [2 /*return*/];
                        }
                        else {
                            console.info("%cSSE reconnect attempt ".concat(attempt, " failed ").concat(now), 'color: #4AAD52');
                            setTimeout(function () { return _this.reconnect(attempt + 1); }, 3000);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        console.error("Can't reconnect after 3 attempt ".concat(now));
                        return [2 /*return*/, Promise.reject()];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    StreamEntity.prototype.reOpenSSE = function () {
        if (this.endpoint) {
            this.reconnect()
                .then(function (instance) { })
                .catch(function (e) { return console.error('an error occurred during reconnect:', e); });
        }
        else {
            console.error('Before reOpen stream Please init SSE first');
        }
    };
    StreamEntity.prototype.parseChannelParam = function (params) {
        if (!params) {
            return '';
        }
        var paramsParsed = Object.entries(params).reduce(function (acc, _a) {
            var key = _a[0], value = _a[1];
            return acc.length ? "".concat(acc, ", ").concat(key, "=").concat(value) : "".concat(key, "=").concat(value);
        }, '');
        return "(".concat(paramsParsed, ")");
    };
    StreamEntity.prototype.parseMessagesIncoming = function (message) {
        var _a;
        var _b = message.data, type = _b.type, id = _b.id, headers = _b.headers, body = _b.body;
        if (type === 'heartbeat') {
            return;
        }
        var channelResponse = headers.feedName;
        var currentChannel = this.channels.find(function (chan) { return chan.channel === channelResponse; });
        if (currentChannel) {
            // Don't retrieve message with same id
            if (this.messageIDProcess.indexOf(id) === -1) {
                currentChannel.eventListener(message.data);
                this.messageIDProcess = this.messageIDProcess.concat(id);
            }
            if (((_a = currentChannel.params) === null || _a === void 0 ? void 0 : _a.sinceId) !== id) {
                currentChannel.params = { sinceId: id };
            }
        }
        else {
            console.log('Channel not handle: feedName => ', channelResponse);
        }
    };
    StreamEntity.prototype.handleErrorConnection = function (err) {
        var _a;
        if (this.errorCallback) {
            this.errorCallback(err);
        }
        var isStopSSEExist = this.stopSSE;
        if (isStopSSEExist) {
            this.stopSSE();
        }
        if ((_a = this.channelsUrl) === null || _a === void 0 ? void 0 : _a.length) {
            console.error('An error occurred during connection to SSE : ', err);
            console.error('An error occurred during connection to SSE : ', err.target.status);
        }
        else {
            console.error('An error occurred during connection to SSE : probably due to no channels subscription', err);
        }
    };
    StreamEntity.streamRunning = [];
    return StreamEntity;
}());
export { StreamEntity };
// retry infini ? compréhension des erreurs plus poussé, trigger des erreurs
// Plusieurs format de SSE prevoir des template pour chaque URL (KYC, NMO, ...)
